import { render, staticRenderFns } from "./Supziliao.vue?vue&type=template&id=abf5d8d0&scoped=true"
import script from "./Supziliao.vue?vue&type=script&lang=js"
export * from "./Supziliao.vue?vue&type=script&lang=js"
import style0 from "./Supziliao.vue?vue&type=style&index=0&id=abf5d8d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf5d8d0",
  null
  
)

export default component.exports